import http from '../axios';

const DONG_DONG_SEND_MESSAGE_URL = '/jdig/dongDong/sendMessage';
const DONG_DONG_LOG_PREFIX = '[DongDong sendMessage]';

export interface DongDongMessageParams {
  traceId: string;
  robotType: number;
  receiveErps: string[];
  message: string;
}

export interface DongDongMessageResponse {
  success?: boolean;
  data?: boolean;
  value?: boolean;
  message?: string;
  msg?: string;
}

/**
 * 发送京 ME / 咚咚消息。
 *
 * 后端接口要求 JSON 入参，axios 拦截器会自动拼接当前环境的 API 域名。
 */
export function sendDongDongMessage(params: DongDongMessageParams): Promise<DongDongMessageResponse> {
  console.log(`${DONG_DONG_LOG_PREFIX} request start`, {
    traceId: params.traceId,
    robotType: params.robotType,
    receiveErps: params.receiveErps,
    messageLength: params.message?.length || 0,
  });

  return new Promise((resolve, reject) => {
    http('jsonpost', DONG_DONG_SEND_MESSAGE_URL, params, false, true).then(
      res => {
        console.log(`${DONG_DONG_LOG_PREFIX} response success`, {
          traceId: params.traceId,
          response: res,
        });
        resolve(res as DongDongMessageResponse);
      },
      error => {
        console.log(`${DONG_DONG_LOG_PREFIX} response error`, {
          traceId: params.traceId,
          error,
        });
        reject(error);
      },
    );
  });
}
